import Vue from "vue";

const state = {
  categories: []
};

const getters = {};

const actions = {
  GET_CATEGORIES: function({ commit }) {
    Vue.prototype.$axios.get("/categories").then(res => {
      console.log(res.data.categories);
      commit("SET_CATEGORIES", res.data.categories);
    });
  }
};

const mutations = {
  SET_CATEGORIES(state, payload) {
    state.categories = payload;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
